import { useNavigate, useParams } from 'react-router';

import { FrameIcon, ReviewsMainIcon } from '@app-velocity/icons';
import { useI18n } from '@app-velocity/i18n';

import { AppraisalsRoutePaths } from '@app-velocity/modules/appraisals';
import { Button } from '@app-velocity/ui';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { HomeCard } from '../HomeCard';
import { WhereToStartLinks } from '../WhereToStartLinks';

export type CreateAReviewCardProps = {
  mode: 'authorized' | 'guest';
  withLinks?: boolean;
};

export const CreateAReviewCard = ({
  mode,
  withLinks,
}: CreateAReviewCardProps) => {
  const { t } = useI18n();
  const { workspaceId, teamId } = useParams<{
    teamId?: string;
    workspaceId?: string;
  }>();
  const navigate = useNavigate();
  const currentTeam = useCurrentTeamPermissions();

  const goToNewPageReview = () => {
    if (mode === 'authorized') {
      if (!workspaceId || !teamId || !currentTeam) return;

      if (!currentTeam.canRunAppraisals()) {
        return;
      }

      navigate(AppraisalsRoutePaths.reviewAPage(teamId, workspaceId));
    } else {
      navigate(AppraisalsRoutePaths.reviewAPageAsAGuest());
    }
  };

  const reviewsButtonId = `review_page_button${
    mode === 'guest' ? '_guest' : ''
  }`;

  return (
    <HomeCard
      icon={<ReviewsMainIcon />}
      text="appraisals:card_text"
      action={
        <Button
          fullWidth
          variant="basic"
          color="primary"
          onClick={goToNewPageReview}
          data-ph-capture-attribute-id={reviewsButtonId}
        >
          {t('appraisals:review_a_page')}
          <FrameIcon />
        </Button>
      }
      additionalAction={withLinks ? <WhereToStartLinks /> : null}
    />
  );
};
